import request from '@/utils/http';
import { PFX, SRM, SRM_FILE } from '../constant/constant.js';
// 物理仓查询获取列表
export const storageList = (params) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouses`,
        method: 'post',
        data: params
    });
};

// 物流园-导出
export const exportPhysicsWarehouses = data => {
    return request({
        url: `${SRM_FILE}/supplierPhysicsWarehouses/export`,
        method: 'post',
        data
    });
};

// MIP申请
export const MipExamine = (params) => {
    return request({
        url: `${SRM}/commitMipExamine`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 设置物流仓状态
export const setWhStatus = (params) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/setWhStatus`,
        method: 'post',
        data: params
    });
};

// 查看地图定点
export const viewAddressMap = (params) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/viewMap`,
        method: 'post',
        data: params
    });
};

// 物理仓-导出
export const exportWarehouse = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierPhysicsWarehouse`,
        method: 'post',
        data
    });
};

// 所属供应商分页查询
export const querySupplierInfo = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/supplierInfo/query`,
        method: 'post',
        data
    });
};

// 项目信息、人工决策查询
export const queryByFdId = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/approveInfo/queryByFdId`,
        method: 'post',
        data
    });
};

// 租仓方案MIP分页查询
export const queryPageByFdId = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/leaseMip/queryPageByFdId`,
        method: 'post',
        data
    });
};

// 所属合同查询
export const contractWarehouseInfoQuery = data => {
    return request({
        url: `${PFX}/contract/contractWarehouseInfo/physicsWarehouse/query`,
        method: 'post',
        data
    });
};
